/* eslint-disable no-null/no-null */

import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  NgDialogModule,
  SignatureInputComponent,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { IPatient } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';

export interface IMohEnrolmentPatientSignatureData {
  drawnSignature?: string;
  typedSignature?: string;
  consentGiven: boolean;
}

@Component({
  selector: 'pr-moh-enrolment-patient-signature-dialog',
  imports: [NgDialogModule, SignatureInputComponent, MatCheckboxModule],
  templateUrl: './moh-enrolment-patient-signature-dialog.component.html',
  styleUrl: './moh-enrolment-patient-signature-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohEnrolmentPatientSignatureDialogComponent {
  private _dialogRef =
    inject<
      MatDialogRef<
        MohEnrolmentPatientSignatureDialogComponent,
        IMohEnrolmentPatientSignatureData
      >
    >(MatDialogRef);
  patient = inject<WithRef<IPatient>>(MAT_DIALOG_DATA);
  showConsentError = signal(false);

  form = new TypedFormGroup<IMohEnrolmentPatientSignatureData>(
    {
      drawnSignature: new TypedFormControl<string>(''),
      typedSignature: new TypedFormControl<string>(''),
      consentGiven: new TypedFormControl<boolean>(false),
    },
    { validators: [requireOneSignature()] }
  );

  submit(): void {
    if (!this.form.controls.consentGiven.value) {
      this.showConsentError.set(true);
      return;
    }
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this._dialogRef.close(this.form.getRawValue());
  }
}

function requireOneSignature(): ValidatorFn {
  return (control) => {
    const formGroup =
      control as TypedFormGroup<IMohEnrolmentPatientSignatureData>;
    const drawnSignatureCtrl = formGroup.controls.drawnSignature;
    const typedSignatureCtrl = formGroup.controls.typedSignature;
    const noSignatures = !drawnSignatureCtrl.value && !typedSignatureCtrl.value;

    return noSignatures ? { requireOneSignature: true } : null;
  };
}
